// extracted by mini-css-extract-plugin
export default {"title":"FormBlock_title__qIdRz","warn":"FormBlock_warn__Z9OUv","subTitle":"FormBlock_subTitle__yPMha"};